import type React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#111827',
    color: 'white'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    padding: '12px 20px',
    background: '#1f2937',
    borderBottom: '1px solid #374151'
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold'
  },
  select: {
    background: '#374151',
    color: 'white',
    border: '1px solid #4b5563',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 13
  },
  button: {
    background: '#374151',
    color: 'white',
    border: '1px solid #4b5563',
    borderRadius: 4,
    padding: '4px 12px',
    fontSize: 12,
    cursor: 'pointer'
  },
  stats: {
    marginLeft: 'auto',
    fontSize: 12,
    color: '#9ca3af'
  },
  canvas: {
    flex: 1
  },
  message: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    color: '#9ca3af'
  },
  error: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ef4444'
  },
  errorOverlay: {
    position: 'fixed',
    bottom: 20,
    right: 20,
    width: 400,
    maxHeight: 300,
    background: 'rgba(127, 29, 29, 0.95)',
    border: '1px solid #ef4444',
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: 1000
  },
  errorHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 12px',
    background: '#7f1d1d',
    borderBottom: '1px solid #ef4444'
  },
  errorTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#fca5a5'
  },
  errorClearButton: {
    background: '#dc2626',
    color: 'white',
    border: 'none',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 11,
    cursor: 'pointer'
  },
  errorList: {
    maxHeight: 250,
    overflowY: 'auto' as const,
    padding: 8
  },
  errorItem: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 2,
    padding: '6px 8px',
    marginBottom: 4,
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: 4,
    fontSize: 12
  },
  errorNode: {
    color: '#fca5a5',
    fontFamily: 'monospace',
    fontSize: 11
  },
  errorMessage: {
    color: '#fef2f2'
  }
};
